'use client';

import { useEffect } from 'react';

const PENDING = '[data-reveal]:not([data-revealed])';

// One observer for every [data-reveal] element on the page (see globals.css), so
// sections can stay server components instead of each shipping motion/react.
// A MutationObserver picks up elements rendered later (tabs, carousels, route changes).
export default function ScrollReveal() {
  useEffect(() => {
    window.__revealReady = true;
    // Not set when the visitor prefers reduced motion, or when the inline fallback in
    // app/layout.js already un-hid everything because hydration took too long.
    if (!document.documentElement.classList.contains('reveal-on')) return;

    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute('data-revealed', '');
        io.unobserve(entry.target);
      }
    }, { threshold: 0.15 });

    const observe = (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches(PENDING)) io.observe(node);
      node.querySelectorAll(PENDING).forEach((el) => io.observe(el));
    };

    observe(document.body);
    const mo = new MutationObserver((records) => {
      for (const record of records) record.addedNodes.forEach(observe);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);

  return null;
}
